
import React, {Suspense, useEffect,useState, useContext} from 'react';

import './App.css';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallBackComponent from './utils/ErrorFallBackComponent';
import { SessionProvider } from './SessionContext';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import './i18n';
import { BrowserRouter as Router} from "react-router-dom";
import { getConfig } from './loadconfig';
import { MyContext } from './globalContext';
import Redirect from './Redirect';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";


let theme = createTheme({
  palette: {
    primary: {
      main: '#007839'
    }
  },
  typography: {
    fontFamily: ['Ubuntu', 'Arial', 'Helvetica', 'Verdana', 'sans-serif'].join(',')
  },
  button: {
    fontFamily: ['Ubuntu', 'Arial', 'Helvetica', 'Verdana', 'sans-serif'].join(',')
  }
});
theme = responsiveFontSizes(theme);

function usePageTracking() {
  

  useEffect(() => {
    
    const handleRouteChange = () => {
      if (window.gtag) {
        let config = getConfig();
        window.gtag('config', config.GATRACKID, {
          page_path: window.location.href,
          page_title: document.title
        });
      }
    };

    handleRouteChange();

        // Add event listeners for route changes
        window.addEventListener('popstate', handleRouteChange);
        return () => {
          window.removeEventListener('popstate', handleRouteChange);
        };

  }, []);
}

function App() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { setSessionTimeExpData } = useContext(MyContext);

  usePageTracking();

  useEffect(() => {
    let timeout;
    const timeoutPeriod = 10 * 60 * 1000; // 10 minutes in milliseconds
    

    const resetTimeout = () => {
      // console.log("Found user activity, resetting timer.");
      clearTimeout(timeout);
      timeout = setTimeout(handleSessionTimeout, timeoutPeriod);
    };

    const handleSessionTimeout = () => {
      setSessionTimeExpData(true);
      // console.log("Session timed out due to inactivity.");
      setOpen(true); // Open the dialog box
    };

    // Add event listeners for user activity
    const events = ['click', 'keypress', 'scroll'];
    events.forEach(event => {
      window.addEventListener(event, resetTimeout);
    });

    // Initialize the timeout
    resetTimeout();

    // Cleanup event listeners on unmount
    return () => {
      clearTimeout(timeout);
      events.forEach(event => {
        window.removeEventListener(event, resetTimeout);
      });
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    window.location.reload(); // Refresh the page
  };

  return (
    <Router>
    <ThemeProvider theme={theme}>
      <ErrorBoundary fallback={ErrorFallBackComponent}>
      <SessionProvider>
        <div className="App">
        <Redirect />
        <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{t(`timeoutTitle`)}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                  {t(`timeoutMessage`)}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button
                    variant="contained"
                    data-testid="search"
                    color="primary"
                    sx={{
                      textTransform: "initial",
                      borderRadius: "0px !important",
                    }}
                    onClick={handleClose}
                    className="search-btn font16"
                  >
                 
                    OK
                  </Button>
                </DialogActions>
              </Dialog>
        </div>
        </SessionProvider>
      </ErrorBoundary>
    </ThemeProvider>
    </Router>
  );
}

export default function WrappedApp() {return <Suspense fallback="...loading"><App/></Suspense>}
